import Link from "next/link";
import Image from "next/image";
import panda from "@rosette/assets/src/panda.svg";
import { cn } from "@rosette/ts/src/util/cn.js";
import { Modal } from "@rosette/web_components/src/ui/Modal.js";
import { Card } from "@rosette/web_components/src/ui/Card.js";
import { Button } from "@rosette/web_components/src/ui/Button.js";


interface SuggestPandaBotModalProps {
    visible: boolean;
    onAccept: () => void;
    onReject: () => void;
    onClose: () => void;
}


export function SuggestPandaBotModal({
    visible,
    onAccept,
    onReject,
    onClose,
}: SuggestPandaBotModalProps) {
    return (
        // The top padding makes room for the Panda, who peeks out from behind the card.
        <Modal className="pt-[2.5em]" open={visible} onClose={onClose}>
            <Card className="relative flex flex-col gap-3">
                <div
                    className={cn(
                        "group absolute -top-[2.5em] right-[0.2em] -z-10 w-[5em] h-auto",
                        "drop-shadow-lg hover:animate-quick-wiggle motion-reduce:hover:animate-none",
                    )}>
                    <Image
                        className={cn(
                            "w-[5em] h-auto rotate-5 transition-transform duration-400 ease-[ease-in-out]",
                            "group-hover:-translate-y-[0.5em] group-hover:cursor-pointer",
                        )}
                        src={panda}
                        alt="The Panda" />
                </div>

                <h2 className="my-0">Want to play the Panda?</h2>
                <p className="mb-0">
                    You get one free game per day
                    against our ultimate champion!
                    {" "}
                    <Link href="/solved" target="_blank" rel="noopener noreferrer">
                        Learn more.
                    </Link>
                </p>

                <div className="flex flex-col w-full gap-4 mt-3">
                    <Button
                        tone="accent"
                        size="lg"
                        className="w-full"
                        onClick={onAccept}>
                        Play the Panda
                    </Button>

                    <Button
                        size="lg"
                        className="w-full"
                        onClick={onReject}>
                        Play Hard Bot
                    </Button>
                </div>
            </Card>
        </Modal>
    );
}
